(() => {
  if (window.boHowEditorialLoaded) return;
  window.boHowEditorialLoaded = true;
  function initPricing(scope) {
    const root = scope.querySelector('#pricing');
    if (!root || root.dataset.boPricingReady) return;
    root.dataset.boPricingReady = 'true';
    const buttons = [...root.querySelectorAll('[data-price-qty]')];
    const tiers = [...root.querySelectorAll('[data-price-tier]')];
    const base = BigInt(root.dataset.baseCents);
    const money = cents => root.dataset.currency + (Number(cents) / 100).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
    const discount = (minor, rate) => (minor * BigInt(rate) + 5000n) / 10000n;
    function quote(quantity, quantityRate, tierRate) {
      const q = BigInt(quantity), subtotal = base * q;
      const reduced = subtotal - discount(subtotal, quantityRate);
      const net = reduced - discount(reduced, tierRate);
      const unit = (2n * net + q) / (2n * q);
      return {unit, total:unit * q};
    }
    function render(button, announce = true) {
      const quantity = Number(button?.dataset.priceQty || 1);
      const quantityRate = Number(button?.dataset.discountBps || 0);
      const retail = quote(quantity, quantityRate, 0);
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelector('[data-price-note]').textContent = (quantityRate ? root.dataset.discountMessage : root.dataset.noDiscountMessage)
        .replaceAll('{discount}', String(quantityRate / 100)).replaceAll('{quantity}', String(quantity));
      const summaries = tiers.map(row => {
        const result = quote(quantity, quantityRate, Number(row.dataset.tierBps));
        row.querySelector('[data-price-unit]').textContent = money(result.unit);
        row.querySelector('[data-price-saved]').textContent = money(retail.total - result.total);
        return `${row.dataset.tierName}: ${money(result.unit)} ${root.dataset.perPrint}`;
      });
      root.querySelector('[data-price-retail]').textContent = `${money(retail.unit)} ${root.dataset.perPrint}`;
      if (announce) root.querySelector('[data-price-live]').textContent = `${quantity}. ${summaries.join('. ')}.`;
    }
    buttons.forEach(button => button.addEventListener('click', () => render(button)));
    render(buttons.find(button => button.getAttribute('aria-pressed') === 'true') || buttons[0], false);
  }
  function initPrep(scope) {
    const root = scope.querySelector('#files');
    if (!root || root.dataset.boPrepReady) return;
    root.dataset.boPrepReady = 'true';
    const image = new Image();
    image.onload = () => {
      const iw = image.naturalWidth, ih = image.naturalHeight;
      const width = Math.min(iw, ih / .9, Math.max(1, iw * Number(root.dataset.cropWidth) / 100));
      const height = width * .9;
      const x = Math.max(0, Math.min(iw - width, iw * Number(root.dataset.cropX) / 100));
      const y = Math.max(0, Math.min(ih - height, ih * Number(root.dataset.cropY) / 100));
      root.querySelectorAll('canvas').forEach(canvas => {
        const ctx = canvas.getContext('2d');
        if (canvas.dataset.quality === 'low') {
          const tiny = document.createElement('canvas');
          tiny.width = 24; tiny.height = 22;
          tiny.getContext('2d').drawImage(image, x, y, width, height, 0, 0, 24, 22);
          ctx.imageSmoothingEnabled = false;
          ctx.drawImage(tiny, 0, 0, canvas.width, canvas.height);
        } else {
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(image, x, y, width, height, 0, 0, canvas.width, canvas.height);
        }
      });
    };
    image.src = root.dataset.art;
  }
  function init() {
    const scope = document.getElementById('bo-how-editorial');
    if (!scope) return;
    initPricing(scope); initPrep(scope); updateNav();
  }
  function updateNav() {
    const scope = document.getElementById('bo-how-editorial');
    if (!scope) return;
    // Theme sticky header can hide/show as the user scrolls. Use its current visible edge.
    const header = document.querySelector('.header__sticky.sticky, .shopify-section-header-sticky, sticky-header');
    const box = header?.getBoundingClientRect();
    const offset = box && box.top <= 1 && box.bottom > 0 ? box.bottom : 0;
    scope.style.setProperty('--bo-header-offset', `${offset}px`);
    const links = [...scope.querySelectorAll('.jump-nav a')].filter(link => {
      const local = link.origin === location.origin && link.pathname === location.pathname && link.hash;
      link.hidden = Boolean(local && !document.getElementById(link.hash.slice(1)));
      return !link.hidden && local;
    });
    let current = links[0];
    const navHeight = scope.querySelector('.jump-nav')?.offsetHeight || 60;
    for (const link of links) {
      const target = document.getElementById(link.hash.slice(1));
      if (target && target.getBoundingClientRect().top <= offset + navHeight + 30) current = link;
    }
    links.forEach(link => link === current ? link.setAttribute('aria-current','location') : link.removeAttribute('aria-current'));
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {pending = false; updateNav();});
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('animationend', schedule, true);
  document.addEventListener('transitionend', schedule, true);
  const stickyHeader = document.querySelector('.header__sticky');
  if (stickyHeader) new ResizeObserver(schedule).observe(stickyHeader);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:block:select', event => {
    const button = event.target.closest('[data-price-qty]');
    if (button) button.click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
